document.addEventListener("DOMContentLoaded", () => {
  const getScrollbarWidth = () => window.innerWidth - document.documentElement.clientWidth;
  document.documentElement.style.setProperty("--scrollbar-width", `${getScrollbarWidth()}px`);

  document.querySelectorAll(".hover-video").forEach((elm) => {
    elm.addEventListener("mouseenter", () => {
      let video = elm.querySelector("video-media");
      if (video) {
        video.play({ restart: true });
        video.setAttribute("loaded", true);
      }
    });
    elm.addEventListener("mouseleave", () => {
      let video = elm.querySelector("video-media");
      if (video) {
        video.pause();
        video.removeAttribute("loaded");
      }
    });
  });

  document.addEventListener("click", (event) => {
    if (event.target.closest(".show_variants")) {
      const productCard = event.target.closest(".product-card");
      if (productCard) {
        productCard.classList.toggle("showing-variants");
      }
    }
  });

  document.querySelectorAll("slideshow-carousel").forEach((slider) => {
    let isInvalid = false;
    let thumbSlider = slider.querySelector(".slideshow__thumb_controls");
    if (thumbSlider) {
      let sliderImages = thumbSlider.querySelectorAll("carousel-navigation .small--thumbnail");
      let slides = slider.querySelectorAll(".slideshow__slide");
      slides.forEach((slide, i) => {
        let slideSrc = slide.querySelector(".content-box").dataset.src;
        if (!slideSrc || slideSrc.includes("Liquid error")) {
          isInvalid = true;
        }
      });
      if (!isInvalid) {
        slides.forEach((slide, i) => {
          let slideSrc = slide.querySelector(".content-box").dataset.src;
          if (slideSrc && !slideSrc.includes("Liquid error")) {
            sliderImages[i].src = slideSrc;
            sliderImages[i].classList.remove("hidden");
          }
        });
      } else {
        thumbSlider.classList.add("hidden");
      }
    }
  });

  setVariant();

  document.addEventListener("theme:recommendations_loaded", function () {
    setVariant();
  });

  setTimeout(() => {
    document.querySelectorAll('.hot-spot__dot[data-open="true"]').forEach((button) => {
      const target = button.getAttribute("aria-controls");
      const targetPopup = document.querySelector("#" + target);
      targetPopup.classList.add("is-open");
      targetPopup.setAttribute("open", "open");
    });
  }, 1500);
});

function setVariant() {
  document.querySelectorAll("product-card.product-card--custom").forEach((card) => {
    const productId = card.dataset.productId;
    const cardProduct = card.querySelector("script[data-product]")
      ? JSON.parse(card.querySelector("script[data-product]").innerText)
      : null;
    const currentVariant = card.querySelector("script[data-variant]")
      ? JSON.parse(card.querySelector("script[data-variant]").innerText)
      : null;
    if (!cardProduct || !currentVariant) {
      console.warn(`Product object not found for card ${productId}`);
      return;
    }

    const productForms = card.querySelectorAll("product-form");
    const colorOptionIndex = cardProduct.options.findIndex((option) => option === "Color");
    const sizeOptionIndex = cardProduct.options.findIndex((option) => option === "Size");

    // --- Core updater ---
    const updateVariantIds = (color) => {
      productForms.forEach((form) => {
        const sizeInput = form.querySelector("input[name='size']:checked"); // ✅ support multiple sizes
        const hiddenVariantInput = form.querySelector("input[name='id']");
        if (!hiddenVariantInput) return;

        let size = sizeInput?.value;

        // If no size selected, auto-pick the first available size input
        if (!size && sizeOptionIndex >= 0) {
          const firstSizeInput = form.querySelector("input[name='size']");
          if (firstSizeInput) {
            firstSizeInput.checked = true;
            size = firstSizeInput.value;
          }
        }

        if (!size) return;

        // Find matching variant in product variants
        const matchedVariant = cardProduct.variants.find((variant) => {
          const hasColor = variant.option1 === color || variant.option2 === color || variant.option3 === color;
          const hasSize = variant.option1 === size || variant.option2 === size || variant.option3 === size;
          return hasColor && hasSize;
        });

        if (matchedVariant) {
          hiddenVariantInput.value = matchedVariant.id;

          const actionButton = form.querySelector(".floating-size-selector__button");
          if (actionButton) {
            if (matchedVariant.available) {
              actionButton.removeAttribute("disabled");
              actionButton.classList.remove("is-disabled");
            } else {
              actionButton.setAttribute("disabled", "disabled");
              actionButton.classList.add("is-disabled");
            }
          }
        }
      });
    };

    // --- Initial setup ---
    let currentColor = currentVariant.options[colorOptionIndex];
    updateVariantIds(currentColor);

    // --- Scoped event delegation per card ---
    card.addEventListener("change", (event) => {
      // Handle swatch change
      if (event.target.closest(".product-card__swatch-list input[type='radio']")) {
        const swatchValue = event.target.dataset.value || event.target.value;
        updateVariantIds(swatchValue);
      }

      // Handle size change (keep color consistent)
      if (event.target.matches("input[name='size']")) {
        const currentColor =
          card.querySelector(".product-card__swatch-list input[type='radio']:checked")?.dataset.value ||
          currentVariant.options[colorOptionIndex];
        updateVariantIds(currentColor);
      }
    });

    card.addEventListener("click", (event) => {
      if (event.target.closest(".floating-size-selector__button")) {
        let parentForm = event.target.closest("product-form");
        if (parentForm) {
          let currentId = parentForm.querySelector("input[name='id']").value;
          let redirectUrl = `/products/${cardProduct.handle}?variant=${currentId}`;
          window.location.href = redirectUrl;
        }
      }
    });
  });
}

// Text Rotate Animation Start
document.addEventListener("DOMContentLoaded", function () {
  let elm = document.querySelectorAll('[effect="word-fade"]');
  elm.forEach((itr) => {
    const rotatingMain = itr.querySelector(".rotating-text");
    const rotatingContainer = rotatingMain.querySelector("em");
    const rotatingWords = rotatingMain.dataset.words;
    const rotatingInterval = rotatingMain.dataset.interval || 3000;
    if (!rotatingContainer || !rotatingWords) return;

    // Split the <em> content into words (comma or space separated)
    const words = rotatingWords.split(/,\s*/).map((w) => w.trim());
    let currentIndex = 0;

    // Set initial word
    rotatingContainer.textContent = words[currentIndex];

    setInterval(() => {
      // Fade out
      rotatingContainer.classList.add("fade-out");

      setTimeout(() => {
        // Switch word
        currentIndex = (currentIndex + 1) % words.length;
        rotatingContainer.textContent = words[currentIndex];

        // Fade in
        rotatingContainer.classList.remove("fade-out");
      }, rotatingInterval * 0.25); // match CSS transition duration
    }, rotatingInterval); // change every 3s
  });
});

// Text Rotate Animation End

// animation image blue reveal start
document.addEventListener("DOMContentLoaded", function () {
  // --- IntersectionObserver to toggle .revealed on enter/leave ---
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("revealed");
        }
      });
    },
    {
      threshold: 0.4, // fire when crossing 40% visibility (in or out)
    }
  );

  // Track what we've already attached (avoids duplicate .observe calls)
  const observed = new WeakSet();

  // Observe all <img> in a given root (defaults to document)
  function observeAllImages(root) {
    const scope = root || document;
    const imgs = scope.querySelectorAll(
      ".product-card__figure img, .media-blocks__item  img, .tab_section_wrap_img img, .blog-post-list-wrapper img, blog-post-list img"
    );
    imgs.forEach((img) => {
      if (!observed.has(img)) {
        io.observe(img);
        observed.add(img);
      }
    });
  }

  // 1) Initial pass
  observeAllImages();

  // 2) Observe images added later (popups injecting DOM, slick clones/lazy-load)
  const mo = new MutationObserver((mutationList) => {
    mutationList.forEach((m) => {
      // If new nodes were added, scan them for <img>
      m.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return; // not an element
        if (node.tagName === "IMG") {
          if (!observed.has(node)) {
            io.observe(node);
            observed.add(node);
          }
        } else {
          observeAllImages(node); // scan inside containers (e.g., popup content)
        }
      });
    });
  });
  mo.observe(document.body, { childList: true, subtree: true });

  // 3) Slick-specific: when slick initializes or changes, make sure any
  //    newly-created slides/clones/lazy images are being observed.
  if (window.jQuery) {
    jQuery(document).on("init reInit setPosition afterChange lazyLoaded", ".builder_data_slide", function () {
      // limit scanning to this slider for efficiency
      observeAllImages(this);
    });

    // If sliders are already on the page, also hook now
    jQuery(".builder_data_slide").each(function () {
      observeAllImages(this);
    });
  }

  // 4) Optional: if your popup library emits open/close events, hook them:
  // Example for a generic popup with event "popup:open"
  document.addEventListener("popup:open", function (e) {
    observeAllImages(e.target || document);
  });

  // 5) Optional: handle viewport size/orientation changes gracefully
  window.addEventListener("orientationchange", () => io.takeRecords());
  window.addEventListener("resize", () => io.takeRecords());
});
// animation image blur reveal end

(function () {
  // Scope to just this product-gallery instance
  const root = (document.currentScript && document.currentScript.closest("product-gallery")) || document;
  const carousel = root.querySelector("scroll-carousel.product-gallery__carousel");
  if (!carousel || carousel.dataset.infinityInit === "1") return;

  // Collect *real* slides (exclude the filler cell and hidden variant-filtered slides)
  const realSlides = Array.from(carousel.querySelectorAll(".product-gallery__media:not(.product-gallery__media-empty):not([hidden])"));
  if (realSlides.length < 2) return;

  carousel.dataset.infinityInit = "1";

  // Clone a full set for both sides
  const makeSet = (slides) => {
    const frag = document.createDocumentFragment();
    slides.forEach((s) => {
      const c = s.cloneNode(true);
      c.classList.add("is-clone");
      frag.appendChild(c);
    });
    return frag;
  };

  // Keep references to originals before mutation
  const firstOriginal = realSlides[0];
  const lastOriginal = realSlides[realSlides.length - 1];

  // Prepend and append one full set each side: [leftSet][originals][rightSet]
  const leftSet = makeSet(realSlides);
  const rightSet = makeSet(realSlides);
  carousel.insertBefore(leftSet, firstOriginal);
  carousel.appendChild(rightSet);

  // After layout paints, position user at the start of the middle set
  const init = () => {
    // Distance from start of middle set to start of right set = one "cycle" width
    const originalsStart = firstOriginal.offsetLeft;
    // Try to get the start of the next set by finding the first clone after the originals
    const firstRightClone = carousel.querySelector(".is-clone"); // first clone in DOM (left or right) — we need the first clone *after* originals
    // Safer cycle width calc (works even if above is ambiguous):
    const cycleWidth = lastOriginal.offsetLeft + lastOriginal.offsetWidth - originalsStart;

    // Center user on the middle set
    carousel.scrollLeft = originalsStart;

    // Throttled scroll handler; re-center when we drift too far
    let ticking = false;
    const handle = () => {
      ticking = false;
      const x = carousel.scrollLeft;

      // If we scrolled too far left (into the left clone set), push forward by one cycle
      if (x < originalsStart - cycleWidth * 0.5) {
        carousel.scrollLeft = x + cycleWidth;
        return;
      }
      // If we scrolled too far right (into the right clone set), pull back by one cycle
      if (x > originalsStart + cycleWidth * 1.5) {
        carousel.scrollLeft = x - cycleWidth;
      }
    };

    carousel.addEventListener(
      "scroll",
      () => {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(handle);
        }
      },
      { passive: true }
    );

    // If theme code re-measures height on resize, ensure layout is stable after we recenter
    window.addEventListener("resize", () => {
      // Recompute anchors (images may have changed widths)
      const newStart = firstOriginal.offsetLeft;
      const newWidth = lastOriginal.offsetLeft + lastOriginal.offsetWidth - newStart;
      // Nudge current position to same visual slide in middle set
      const diff = newStart - originalsStart;
      carousel.scrollLeft = carousel.scrollLeft + diff;
    });
  };

  if (document.readyState === "complete") {
    init();
  } else {
    window.addEventListener("load", init, { once: true });
  }
})();
